import { connectRouter }                from 'connected-react-router';
import { combineReducers }              from 'redux';
import { createAction, createReducer }  from 'redux-act';

import { Game }              from '../models/Game';
import { User }              from '../models/User';
import { UserAuthStatus }    from '../models/UserAuthStatus';
import { Wrappers }          from '../models/AARPWrappers';
import { GameState, FriendActionState }         from '../models/Enums';
import { ScoreBoxModel }     from '../models/ScoreBoxModel';
import { HomePageSorting }   from '../models/HomePageSorting';
import { ScoreFilterModel}   from '../models/ScoreFilterModel';
import { FriendPopupModel }  from '../models/FriendPopuModel';

// SDK
export type TArkadiumSdkStore = ArkadiumSdkInstance | null;

export const setGames = createAction<Game[]>('add games');
export const setUser = createAction<User>('set user');
export const setUserAuthStatus = createAction<UserAuthStatus>('set user pending');
export const set404Status = createAction<boolean>('set 404 status');
export const setWrappers = createAction<Wrappers>('set wrappers');
export const setGameState = createAction<GameState>('set game status');
export const setScoreBox = createAction<ScoreBoxModel>('set score box');
export const setFriendPopupState = createAction<FriendPopupModel>('set friend popup');
export const setFriendActionState = createAction<FriendActionState>('set friend action state');
export const setHomePageSorting = createAction<HomePageSorting[]>('set home page sorting');
export const setPromo = createAction<any>('set promo for home page');
export const setScoreFilter = createAction<ScoreFilterModel[]>('set score filter');
export const setNotificationBanner = createAction<any>('set NotificationBanner for home page');
export const setGamePreviews = createAction<any>('set preview mode');
export const setTheaterMode = createAction<boolean>('set theater mode');
export const setSdkLoaded = createAction<TArkadiumSdkStore>('set on SDK loaded');

// Games
const defaultState: Game[] = [];

const gameReducer = createReducer<typeof defaultState>({}, defaultState);
gameReducer.on(setGames, (_state, payload: Game[] = []) => payload.slice(0));

// User
const userReducer = createReducer<User>({}, null);
userReducer.on(setUser, (_state, payload: User = null) => payload);

const wrappersReducer = createReducer<any>({}, {});
wrappersReducer.on(setWrappers, (_state, payload: Wrappers = {}) => payload);

// User Pending
const userAuthStatusReducer = createReducer<UserAuthStatus>(
  {},
  UserAuthStatus.PENDING
);
userAuthStatusReducer.on(
  setUserAuthStatus,
  (_state, payload: UserAuthStatus) => payload
);

const is404StatusReducer = createReducer<boolean>({}, false);
is404StatusReducer.on(set404Status, (_state, payload: boolean) => !!payload);

const gameStateReducer = createReducer<GameState>({}, GameState.PENDING);
gameStateReducer.on(setGameState, (_state, payload: GameState) => payload);

const friendPopupStateReducer = createReducer<FriendPopupModel>({}, null);
friendPopupStateReducer.on(
  setFriendPopupState,
  (_state, payload: FriendPopupModel) => payload
);

const friendActionStateReducer = createReducer<FriendActionState>(
  {},
  FriendActionState.Pending
);
friendActionStateReducer.on(
  setFriendActionState,
  (_state, payload: FriendActionState) => payload
);

const scoreBoxReducer = createReducer<ScoreBoxModel>({}, null);
scoreBoxReducer.on(setScoreBox, (_state, payload: ScoreBoxModel) => payload);

const defaultHomePageSorting: HomePageSorting[] = [];
const homePageSortingReducer = createReducer<typeof defaultHomePageSorting>(
  {},
  defaultHomePageSorting
);
homePageSortingReducer.on(
  setHomePageSorting,
  (_state, payload: HomePageSorting[] = []) => payload.slice(0)
);

const promoReducer = createReducer<any>({}, null);
promoReducer.on(setPromo, (_state, payload: any) => payload);

const defaultScoreFilterModel: ScoreFilterModel[] = [];
const setScoreFilterReducer = createReducer<typeof defaultScoreFilterModel>(
  {},
  defaultScoreFilterModel
);
setScoreFilterReducer.on(
  setScoreFilter,
  (_state, payload: ScoreFilterModel[] = []) => payload.slice(0)
);

const notificationBannerReducer = createReducer<any>({}, null);
notificationBannerReducer.on(setNotificationBanner, (_state, payload: any) => payload);

const gamePreviewsReducer = createReducer<any>({}, null);
gamePreviewsReducer.on(setGamePreviews, (_state, payload: any) => payload);

const isTheaterModeReducer = createReducer<boolean>({}, false);
isTheaterModeReducer.on(setTheaterMode, (_state, payload: boolean) => !!payload);

const sdkLoadedReducer = createReducer<TArkadiumSdkStore>({}, null);
sdkLoadedReducer.on(setSdkLoaded, (_state, payload: TArkadiumSdkStore | null) => payload);

export default (history) => combineReducers({
    router: connectRouter(history),
    games: gameReducer,
    user: userReducer,
    is404: is404StatusReducer,
    wrappers: wrappersReducer,
    userAuthStatus: userAuthStatusReducer,
    gameState: gameStateReducer,
    scoreBox: scoreBoxReducer,
    friendPopupState: friendPopupStateReducer,
    friendActionState: friendActionStateReducer,
    homePageSorting: homePageSortingReducer,
    promo: promoReducer,
    scoreFilter: setScoreFilterReducer,
    notificationBanner: notificationBannerReducer,
    gamePreviews: gamePreviewsReducer,
    isTheaterMode: isTheaterModeReducer,
    sdkLoaded: sdkLoadedReducer,
  });
